import axios from '../utils/axios'

function request(functionId, body) {
  let data = {
    functionId,
    body,
  }
  return axios.request({
    data: data,
    method: 'post'
  })
}
// 疾病库名称
export function queryDiseaseLibraryName(body) {
  return request("health_cmp_pageDiseaseInfoByParam", body);
}

// 医生名称查询
export function queryDoctorName(body) {
  return request("health_cmp_listByDoctorName", body);
}

// 业务查询
export function queryBusiness(body) {
  return request("health_cmp_biz_queryContentUserManInfo", body);
}

// 栏目查询
export function queryColumn(body) {
  return request("health_cmp_biz_pageContentCategories", body);
}

// 频道查询
export function queryChannel(body) {
  return request("health_cmp_biz_pageContentChannels", body);
}

// 问答状态查询
export function queryQuestionState(body) {
  return request("health_cmp_biz_listAuditStatus", body);
}

// 来源查询
export function querySource(body) {
  return request("health_cmp_biz_queryContentSource", body);
}

// 问答查询状态数量
export function queryQuestionStateNum(body) {
  return request("health_cmp_queryContentDraftCountList", body);
}

// 问答查询列表
export function queryQuestionList(body) {
  return request("health_cmp_queryContentDrafts", body);
}

// 下线
export function offlineApplication(body) {
  return request("health_cmp_updateContentStatus", body);
}

// 修改问题接口
export function modifyQuestion(body) {
  return request("health_cmp_biz_manUpdateQuestion", body);
}
// 修改答案接口
export function modifyAnswer(body) {
  return request("health_cmp_biz_manUpdateAnswer", body);
}

// 通过
export function adoptQuestion(body) {
  return request("health_cmp_manPassContent", body);
}

// 驳回
export function rejectQuestion(body) {
  return request("health_cmp_manRejectContent", body);
}

// 提交
export function submitQuestion(body) {
  return request("health_cmp_biz_manSubmitQuestionAnswer", body);
}

// 标签查询
export function queryLabel(body) {
  return request("health_cmp_biz_pageAuditLabels", body);
}

// 业务栏目频道查询
export function queryAuditBusinessDetail(body) {
  // return request("health_cmp_biz_pageAuditBusinessDetail", body);
  return request("health_cmp_biz_pageManContentBusiness", body);
}

// 详情段落
export function queryListParagraph(body) {
  return request("health_cmp_biz_listParagraph", body);
}

// 根据id查问答
export function queryQAById(body) {
  return request("health_cmp_queryContentDraftById", body);
}

// 导入问答
export function importQuestionAnswer(body) {
  return request("health_cmp_biz_importExcel", body);
}
// 导入类目
export function importInContentCategory(body) {
  return request("health_cmp_biz_importExcel", body);
}
// 导出类目
export function importOutContentCategory(body) {
  return request("health_cmp_biz_exportExcel", body);
}
// 导出导出轮询
export function importExportLog(body) {
  return request("health_cmp_biz_queryExcelResult", body);
}

// 获取文章状态
export function getContentStatus(body) {
  return request("health_cmp_biz_listContentStatus", body);
}

// 获取内容分发楼层信息
export function getContentAttribute(body) {
  return request("health_cmp_biz_listManBaikeAttribute", body);
}
